import React from 'react';
import { Flex } from 'antd';

import { FinanceContainer } from './containers/FinanceContainer';
import { FinanceChart } from './components/FinanceChart';

export const AnalyticsFinance = () => {
    return (
        <Flex gap={16} vertical>
            <Flex gap={16} justify={'space-between'} wrap={'wrap'}>
                <Flex flex='0 0 50%'>
                    <FinanceChart />
                </Flex>
            </Flex>
            <FinanceContainer />
        </Flex>
    );
};
